@for (v of visibilities; track v) {
  <div class="rounded clickable bordered padded tight"
       [class.text-bg-primary]="control().value === v"
       (click)="control().setValue(v)"
  >
    <app-visibility [value]="v"/>
  </div>
}
